// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.main-sidebar {
  width: 250px;
  height: 100vh;
  padding: 0 12px;
  background-color: #12265f;
  display: flex;
  flex-direction: column;
  z-index: 100;
}
.main-sidebar-toggle {
  right: -50px;
  top: 18px;
  z-index: 999;
  padding: 2px 3px !important;
  box-shadow: 1px 1px 3px rgba(18, 38, 95, 0.168627451);
}
.main-sidebar-toggle svg {
  width: 32px;
  height: 32px;
}
.main-sidebar .logout-and-getapp {
  overflow: visible;
  margin-bottom: 10px;
}
.main-sidebar .logout-and-getapp li {
  margin-bottom: 5px;
}
.main-sidebar-logo {
  width: 80px;
  margin: 0 auto 45px;
}
.main-sidebar-menu {
  max-height: 64vh;
  overflow-y: auto;
}
.main-sidebar-menu-single {
  margin-bottom: 15px;
}
.main-sidebar-menu-single:last-child {
  margin-bottom: 0;
}
.main-sidebar-menu-single-a {
  padding: 10px;
  border-radius: 5px;
  display: block;
  color: #bcceff;
  background-color: transparent;
  border: none;
  text-align: left;
  border: none;
  gap: 15px;
  font-size: 14px;
}
.main-sidebar-menu-single-a:hover, .main-sidebar-menu-single-a.active {
  background-color: rgba(94, 108, 147, 0.4117647059);
  color: #fff;
}
.main-sidebar-menu-single-a:hover g, .main-sidebar-menu-single-a.active g {
  fill: #fff;
}
.main-sidebar-menu-single-a svg {
  width: 22px;
  height: auto;
  flex-shrink: 0;
}
.main-sidebar-menu-single-a svg g {
  fill: #bcceff;
}
.main-sidebar-menu-dropdown-btn-arrow {
  width: 15px !important;
  margin-left: auto;
}
.main-sidebar-menu-dropdown-collapse-list-single-a {
  color: #bcceff;
  padding: 9px 0 9px 15px;
  display: block;
}
.main-sidebar-menu-dropdown-collapse-list-single-a:before {
  content: "•";
  margin-right: 10px;
}
.main-sidebar-menu-dropdown-collapse-list-single-a:hover, .main-sidebar-menu-dropdown-collapse-list-single-a.active {
  color: #fff;
}
@media (max-width: 1199px) {
  .main-sidebar {
    position: fixed !important;
    transform: translateX(-100%);
    transition: 0.6s;
  }
}
@media (min-width: 1200px) {
  .main-sidebar.minimized {
    width: 63px;
  }
  .main-sidebar.minimized .main-sidebar-logo {
    width: 36px;
  }
  .main-sidebar.minimized .main-sidebar-menu {
    overflow: visible;
  }
  .main-sidebar.minimized .main-sidebar-menu-single-a.btn-toggle {
    cursor: auto;
  }
  .main-sidebar.minimized .main-sidebar-menu-single-a + .main-sidebar-menu-dropdown-collapse {
    display: none;
  }
  .main-sidebar.minimized .main-sidebar-menu-single:hover .main-sidebar-menu-single-a {
    width: 150px !important;
    background-color: #e7d993 !important;
    color: #000;
  }
  .main-sidebar.minimized .main-sidebar-menu-single:hover .main-sidebar-menu-single-a svg {
    display: inline-block;
  }
  .main-sidebar.minimized .main-sidebar-menu-single:hover .main-sidebar-menu-single-a svg g {
    background-color: #e7d993 !important;
    color: #000;
    fill: #000;
  }
  .main-sidebar.minimized .main-sidebar-menu-single:hover .main-sidebar-menu-single-a + .main-sidebar-menu-dropdown-collapse {
    background-color: #e7d993;
    width: 150px;
    display: block;
    position: absolute;
  }
  .main-sidebar.minimized .main-sidebar-menu-single:hover .main-sidebar-menu-single-a + .main-sidebar-menu-dropdown-collapse .main-sidebar-menu-dropdown-collapse-list-single-a:hover {
    background-color: #d3c57d;
  }
  .main-sidebar.minimized .main-sidebar-menu-single:hover .main-sidebar-menu-single-a + .main-sidebar-menu-dropdown-collapse .main-sidebar-menu-single-a-text {
    display: inline-block;
  }
  .main-sidebar.minimized .main-sidebar-menu-single:hover .main-sidebar-menu-single-a .main-sidebar-menu-single-a-text {
    display: block;
  }
  .main-sidebar.minimized .main-sidebar-menu-single-a-text {
    display: none;
  }
  .main-sidebar.minimized .main-sidebar-menu-dropdown-btn-arrow {
    display: none;
  }
  .main-sidebar.minimized .main-sidebar-menu-dropdown-collapse-list-single-a {
    color: #000;
  }
  .main-sidebar.minimized + .main-page-row-right, .main-sidebar.minimized + .main-page-row-right .main-header {
    width: calc(100vw - 63px);
  }
}
@media (max-width: 1199px) {
  .main-sidebar.minimized {
    transform: translateX(0);
    transition: 0.6s;
  }
  .main-sidebar.minimized + .main-page-row-right, .main-sidebar.minimized + .main-page-row-right .main-header {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/sidebar/sidebar.scss","webpack://./src/assets/css/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB;EACE,YCEa;EDDb,aAAA;EACA,eAAA;EACA,yBCES;EDDT,aAAA;EACA,sBAAA;EACA,YAAA;AADF;AAGE;EACE,YAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;EACA,qDAAA;AADJ;AAGI;EACE,WAAA;EACA,YAAA;AADN;AAKE;EACE,iBAAA;EACA,mBAAA;AAHJ;AAME;EACE,kBAAA;AAJJ;AAOE;EACE,WAAA;EACA,mBAAA;AALJ;AAQE;EACE,gBAAA;EACA,gBAAA;AANJ;AAQI;EACE,mBAAA;AANN;AAQM;EACE,gBAAA;AANR;AASM;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;AAPR;AASQ;EAEE,kDAAA;EACA,WC7DK;ADqDf;AAUU;EACE,UChEG;ADwDf;AAYQ;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAVV;AAYU;EACE,aAAA;AAVZ;AAkBQ;EACE,sBAAA;EACA,iBAAA;AAhBV;AAsBU;EACE,cAAA;EACA,uBAAA;EACA,cAAA;AApBZ;AAsBY;EACE,YAAA;EACA,kBAAA;AApBd;AAuBY;EAEE,WCtGC;ADgFf;AA8BE;EA/GF;IAgHI,0BAAA;IACA,4BAAA;IACA,gBAAA;EA3BF;AACF;AA8BI;EADF;IAEI,WAAA;EA3BJ;EA8BM;IACE,WAAA;EA5BR;EA+BM;IACE,iBAAA;EA7BR;EAiCY;IACE,YAAA;EA/Bd;EAkCY;IACE,aAAA;EAhCd;EAqCY;IACE,uBAAA;IACA,oCAAA;IACA,WAAA;EAnCd;EAqCc;IACE,qBAAA;EAnChB;EAqCgB;IACE,oCAAA;IACA,WAAA;IACA,UAAA;EAnClB;EAuCc;IACE,yBC9JF;ID+JE,YAAA;IACA,cAAA;IACA,kBAAA;EArChB;EAwCkB;IACE,yBAAA;EAtCpB;EA0CgB;IACE,qBAAA;EAxClB;EA4Cc;IACE,cAAA;EA1ChB;EA+CU;IACE,aAAA;EA7CZ;EAiDQ;IACE,aAAA;EA/CV;EAkDQ;IACE,WAAA;EAhDV;EAqDI;IAEE,yBAAA;EApDN;AACF;AAuDI;EAnFF;IAoFI,wBAAA;IACA,gBAAA;EApDJ;EAsDI;IAEE,WAAA;EArDN;AACF","sourcesContent":["@import \"../../../assets/css/variables.scss\";\n\n\n.main-sidebar {\n  width: $sidebarWidth;\n  height: 100vh;\n  padding: 0 12px;\n  background-color: $mainBlue;\n  display: flex;\n  flex-direction: column;\n  z-index: 100;\n\n  &-toggle {\n    right: -50px;\n    top: 18px;\n    z-index: 999;\n    padding: 2px 3px !important;\n    box-shadow: 1px 1px 3px #12265f2b;\n\n    svg {\n      width: 32px;\n      height: 32px;\n    }\n  }\n\n  .logout-and-getapp {\n    overflow: visible;\n    margin-bottom: 10px;\n  }\n\n  .logout-and-getapp li {\n    margin-bottom: 5px;\n  }\n\n  &-logo {\n    width: 80px;\n    margin: 0 auto 45px;\n  }\n\n  &-menu {\n    max-height: 64vh;\n    overflow-y: auto;\n\n    &-single {\n      margin-bottom: 15px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      &-a {\n        padding: 10px;\n        border-radius: 5px;\n        display: block;\n        color: #bcceff;\n        background-color: transparent;\n        border: none;\n        text-align: left;\n        border: none;\n        gap: 15px;\n        font-size: 14px;\n\n        &:hover,\n        &.active {\n          background-color: #5e6c9369;\n          color: $white-color;\n\n          g {\n            fill: $white-color;\n          }\n        }\n\n        svg {\n          width: 22px;\n          height: auto;\n          flex-shrink: 0;\n\n          g {\n            fill: #bcceff;\n          }\n        }\n      }\n    }\n\n    &-dropdown {\n      &-btn {\n        &-arrow {\n          width: 15px !important;\n          margin-left: auto;\n        }\n      }\n\n      &-collapse-list {\n        &-single {\n          &-a {\n            color: #bcceff;\n            padding: 9px 0 9px 15px;\n            display: block;\n\n            &:before {\n              content: \"•\";\n              margin-right: 10px;\n            }\n\n            &:hover,\n            &.active {\n              color: $white-color;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media(max-width: 1199px) {\n    position: fixed !important;\n    transform: translateX(-100%);\n    transition: 0.6s;\n  }\n\n  &.minimized {\n    @media(min-width: 1200px) {\n      width: 63px;\n\n      .main-sidebar {\n        &-logo {\n          width: 36px;\n        }\n\n        &-menu {\n          overflow: visible;\n\n          &-single {\n            &-a {\n              &.btn-toggle {\n                cursor: auto;\n              }\n\n              &+.main-sidebar-menu-dropdown-collapse {\n                display: none;\n              }\n            }\n\n            &:hover {\n              .main-sidebar-menu-single-a {\n                width: 150px !important;\n                background-color: $golden-color !important;\n                color: #000;\n\n                svg {\n                  display: inline-block;\n\n                  g {\n                    background-color: $golden-color !important;\n                    color: #000;\n                    fill: #000;\n                  }\n                }\n\n                &+.main-sidebar-menu-dropdown-collapse {\n                  background-color: $golden-color;\n                  width: 150px;\n                  display: block;\n                  position: absolute;\n\n                  .main-sidebar-menu-dropdown-collapse-list-single-a {\n                    &:hover {\n                      background-color: #d3c57d;\n                    }\n                  }\n\n                  .main-sidebar-menu-single-a-text {\n                    display: inline-block;\n                  }\n                }\n\n                .main-sidebar-menu-single-a-text {\n                  display: block;\n                }\n              }\n            }\n\n            &-a-text {\n              display: none;\n            }\n          }\n\n          &-dropdown-btn-arrow {\n            display: none;\n          }\n\n          &-dropdown-collapse-list-single-a {\n            color: #000;\n          }\n        }\n      }\n\n      &+.main-page-row-right,\n      &+.main-page-row-right .main-header {\n        width: calc(100vw - 63px);\n      }\n    }\n\n    @media(max-width: 1199px) {\n      transform: translateX(0);\n      transition: 0.6s;\n\n      &+.main-page-row-right,\n      &+.main-page-row-right .main-header {\n        width: 100%;\n      }\n    }\n  }\n\n}","\n\n$golden-color : #e7d993;\n$dark-color : #070f1c;\n$white-color : #fff;\n$gray-color: #a9b0b3;\n$sidebarWidth: 250px;\n$headerHeight: 70px;\n$hoverbg: #f0f4ff;\n$mainBlue: #12265f;\n$dangerRed: #FF6961;\n$orange:  #fd7e14;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
